import { Checkbox, IconButton } from "@mui/material"
import { BodyContainer, Row, Cell, Header, Badge, Table, Footer } from "wed-components-beta"
import { Panel, SortCustomers } from "./AssignBundles"
import { Visibility } from '@mui/icons-material'
import { NewAssignBundlesCustomers, NewViewBundle } from "../types"
// import SortingHeader02 from "../../../assets/SortingHeader02"

type BundlesTableProps = {
  data: NewViewBundle[]
  selectedBundleId: number | null
  setSelectedBundleId: React.Dispatch<React.SetStateAction<number | null>>
}

export function BundlesTable({ data, selectedBundleId, setSelectedBundleId }: BundlesTableProps) {
  const columnWidth = [.5, 3, .6, .6, .9]

  return <Table id='table-bundles'>
    <BodyContainer flexGrow={1}>
      <Header>
        <Cell width={columnWidth[0]}>
          ID
        </Cell>
        <Cell flexGrow>
          Bundle
        </Cell>
        <Cell width={columnWidth[2]}>
          Affil.
        </Cell>
        <Cell width={columnWidth[3]}>
          Ref. Year
        </Cell>
        <Cell width={columnWidth[4]}>
          Vouchers
        </Cell>
      </Header>
      {
        data.length ?
          data.map((_row, index) => <Row key={index} style={_row.id === selectedBundleId ? { backgroundColor: 'rgba(255, 255, 255, .25)' } : {}} onClick={() => setSelectedBundleId(_row.id)}>
            <Cell width={columnWidth[0]}>
              {_row.id}
            </Cell>
            <Cell flexGrow>
              {_row.name}
            </Cell>
            <Cell width={columnWidth[2]}>
              {_row.affiliation_tag}
            </Cell>
            <Cell width={columnWidth[3]}>
              {_row.reference_year}
            </Cell>
            <Cell width={columnWidth[4]}>
              {_row.voucher_amount} ({_row.voucher_type_tag})
            </Cell>
          </Row>)
          :
          <Row>
            <Cell flexGrow>
              No bundles to show.
            </Cell>
          </Row>
      }
    </BodyContainer>
  </Table>
}

type CustomersTableProps = {
  data: NewAssignBundlesCustomers[]
  filteredData: NewAssignBundlesCustomers[]
  selectedCustomers: number[]
  setSelectedCustomers: React.Dispatch<React.SetStateAction<number[]>>
  sort: SortCustomers
  setSort: React.Dispatch<React.SetStateAction<SortCustomers>>
  setPanel: React.Dispatch<React.SetStateAction<Panel>>
}

const defineColor = (student_status_type_name: string | null) => {
  switch (student_status_type_name) {
    case 'Admitted':
      return 'green'
    case 'Canceled':
      return 'red'
    default:
      return 'blue'
  }
}

const renderFontColor = (assigned: number, expected: number) => {
  if (assigned === 0) return '#e6dfa2' // yellow
  if (assigned !== expected) return '#cf7f7f' // red
  return '#a2e6a5' // green
}

export function CustomersTable({ data, filteredData, selectedCustomers, setSelectedCustomers, sort, setSort, setPanel }: CustomersTableProps) {
  const columnWidth = [.5, .5, 3, .9, 1.75, .75, 1, 1, .65]

  return <Table id='table-customers'>
    <BodyContainer flexGrow={1}>
      <Header>
        <Cell width={columnWidth[0]}>
          <Checkbox
            id='checkbox-select-all'
            checked={selectedCustomers.length === filteredData.length && filteredData.length !== 0}
            onChange={(e) => setSelectedCustomers((prev) => e.target.checked ? filteredData.map((_) => _.id) : [])}
            sx={{ transform: 'translateX(-6px)' }}
          />
        </Cell>
        <Cell width={columnWidth[1]}>
          {/* <SortingHeader02 text='ID' column={'id'} sort={sort} setSort={setSort} /> */}
          ID
        </Cell>
        <Cell flexGrow>
          {/* <SortingHeader02 text='Name' column={'customer_name'} sort={sort} setSort={setSort} /> */}
          Name
        </Cell>
        <Cell width={columnWidth[3]}>
          {/* <SortingHeader02 text='Grade' column={'customer_grade_name'} sort={sort} setSort={setSort} /> */}
          Grade
        </Cell>
        <Cell width={columnWidth[4]}>
          {/* <SortingHeader02 text='Program' column={'customer_program_name'} sort={sort} setSort={setSort} /> */}
          Program
        </Cell>
        <Cell width={columnWidth[5]}>
          Credits
        </Cell>
        <Cell width={columnWidth[6]}>
          Assigned / Expected
        </Cell>
        <Cell width={columnWidth[7]}>
          {/* <SortingHeader02 text='Status' column={'student_status_type_name'} sort={sort} setSort={setSort} /> */}
          Status
        </Cell>
        <Cell width={columnWidth[8]}>
          Details
        </Cell>
      </Header>
      {
        selectedCustomers.length ?
          <>
            {
              data.filter((_) => selectedCustomers.includes(_.id)).map((row, index) => <Row key={index}>
                <Cell width={columnWidth[0]}>
                  <Checkbox
                    id={`checkbox-selected-customer-${row.id}`}
                    checked={selectedCustomers.includes(row.id)}
                    onChange={() => setSelectedCustomers((prev) => prev.filter((_id) => _id !== row.id))}
                    sx={{ transform: 'translateX(-6px)' }}
                  />
                </Cell>
                <Cell width={columnWidth[1]}>
                  {row.id}
                </Cell>
                <Cell flexGrow>
                  {row.student_full_name}
                </Cell>
                <Cell width={columnWidth[3]}>
                  {row.grade_name}
                </Cell>
                <Cell width={columnWidth[4]}>
                  {row.program_name}
                </Cell>
                <Cell width={columnWidth[5]}>
                  {row.credits.map((_, index) => <p key={index}>{_.credits.toFixed(1)} ({_.affiliation_tag})</p>)}
                </Cell>
                <Cell width={columnWidth[6]}>
                  {row.vouchers.map((_, index) => <p key={index} style={{ color: renderFontColor(_.assigned, _.expected) }}>{_.assigned}/{_.expected} ({_.affiliation_tag})</p>)}
                </Cell>
                <Cell width={columnWidth[7]}>
                  <Badge color={defineColor(row.student_status_type_name)}>
                    {row.student_status_type_name || ''}
                  </Badge>
                </Cell>
                <Cell width={columnWidth[8]}>
                  {
                    row.vouchers.length ?
                      <IconButton
                        id={`button-details-${row.id}`}
                        onClick={() => setPanel({ show: true, fk_id_student: row.id })}
                        sx={{ width: 36, height: 36 }}
                      >
                        <Visibility />
                      </IconButton>
                      :
                      <></>
                  }
                </Cell>
              </Row>)
            }
            <hr style={{ width: '100%', margin: 0 }} />
          </>
          :
          null
      }
      {
        !filteredData.length ?
          <Row>
            <Cell flexGrow>
              There are still no customers confirmed for this year.
            </Cell>
          </Row>
          :
          filteredData.filter((_) => !selectedCustomers.includes(_.id)).map((row, index) => <Row key={index}>
            <Cell width={columnWidth[0]}>
              <Checkbox
                id={`checkbox-customer-${row.id}`}
                checked={selectedCustomers.includes(row.id)}
                onChange={() => setSelectedCustomers((prev) => prev.concat(row.id))}
                sx={{ transform: 'translateX(-6px)' }}
              />
            </Cell>
            <Cell width={columnWidth[1]}>
              {row.id}
            </Cell>
            <Cell flexGrow>
              {row.student_full_name}
            </Cell>
            <Cell width={columnWidth[3]}>
              {row.grade_name}
            </Cell>
            <Cell width={columnWidth[4]}>
              {row.program_name}
            </Cell>
            <Cell width={columnWidth[5]}>
              {row.credits.map((_, index) => <p key={index}>{_.credits.toFixed(1)} ({_.affiliation_tag})</p>)}
            </Cell>
            <Cell width={columnWidth[6]}>
              {row.vouchers.map((_, index) => <p key={index} style={{ color: renderFontColor(_.assigned, _.expected) }}>{_.assigned}/{_.expected} ({_.affiliation_tag})</p>)}
            </Cell>
            <Cell width={columnWidth[7]}>
              <Badge color={defineColor(row.student_status_type_name)}>
                {row.student_status_type_name || ''}
              </Badge>
            </Cell>
            <Cell width={columnWidth[8]}>
              {
                row.vouchers.length ?
                  <IconButton
                    id={`button-details-${row.id}`}
                    onClick={() => setPanel({ show: true, fk_id_student: row.id })}
                    sx={{ width: 36, height: 36 }}
                  >
                    <Visibility />
                  </IconButton>
                  :
                  <></>
              }
            </Cell>
          </Row>
          )
      }
      <Footer>
        <Cell>
          Total: {data.length}
        </Cell>
        <Cell>
          {
            selectedCustomers.length ?
              <p style={{ fontSize: 13, fontWeight: 'lighter' }}>
                Selected: {selectedCustomers.length}
              </p>
              :
              null
          }
        </Cell>
        <Cell flexGrow>
          {
            filteredData.length < data.length ?
              <p style={{ fontSize: 13, fontWeight: 'lighter' }}>
                Shown (filtered): {filteredData.length} ({data.length - filteredData.length})
              </p>
              :
              null
          }
        </Cell>
      </Footer>
    </BodyContainer>
  </Table>
}